import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=61161d9c&"
import script from "./Grid.vue?vue&type=script&lang=ts&"
export * from "./Grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports